import { CertificadoService } from '../../shared/service/certificado/certificado.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Certificado } from '../../shared/index';
import { Location } from '@angular/common';
import { LoginService } from '../../shared/service/login/login.service';
import { UtilService } from '../../shared/service/util/util.service';

@Component({
  selector: 'app-certificado-form',
  templateUrl: './certificado-form.component.html',
  styleUrls: ['./certificado-form.component.css']
})
export class CertificadoFormComponent implements OnInit {
  certificado: Certificado = new Certificado();

  constructor(
    private route: ActivatedRoute,
    private certificadoService: CertificadoService,
    private _location: Location,
    private loginService: LoginService,
    private utilService: UtilService) {

    const idUsuario = JSON.parse(localStorage.getItem("currentUser")).id;

    this.route.params.subscribe(params => {
      if (params["id"]) {
        let id = params["id"];

        this.certificadoService.getDetalheCertificado(id, idUsuario).then((certResponse) => {
          this.certificado = certResponse;
        }).catch(error => {
          if (error.status === 401 || error.status === 403) {
            this.loginService.logout();
          }
          this.utilService.showError(error.message || error);
        });
      }
    });
  }

  ngOnInit() {
  }

  voltar() {
    this._location.back();
  }
}